import store from '@/store'
import Vue from 'vue'

export function handleError(e) {
  if (!e.response) {
    return;
  }
  switch (e.response.status) {
    case 401:
      store.dispatch('logout', true);
      break;
    default:
      if (e.response.data.hasOwnProperty('message')) {
        Vue.$notify.danger(e.response.data.message);
      }
      break;
  }
}
